import { finalRegex, iidxes } from "./regex";
const list = (input) => {
    const found = [];
    let result = null;
    do {
        result = finalRegex.exec(input);
        if (result) {
            const start = result.index;
            const end = start + result[0].length;
            const string = result[0];
            if (result[iidxes.isURL]) {
                const path = (result[iidxes.url.path] || "") +
                    (result[iidxes.url.secondPartOfPath] || "") || undefined;
                const protocol = result[iidxes.url.protocol1] ||
                    result[iidxes.url.protocol2] ||
                    result[iidxes.url.protocol3];
                found.push({
                    start,
                    end,
                    string,
                    isURL: true,
                    protocol,
                    port: result[iidxes.url.port],
                    ipv4: result[iidxes.url.ipv4Confirmation]
                        ? result[iidxes.url.ipv4]
                        : undefined,
                    ipv6: result[iidxes.url.ipv6],
                    host: result[iidxes.url.byProtocol]
                        ? undefined
                        : (result[iidxes.url.protocolWithDomain] || "").substr((protocol || "").length),
                    confirmedByProtocol: !!result[iidxes.url.byProtocol],
                    path: result[iidxes.url.byProtocol] ? undefined : path,
                    query: result[iidxes.url.query] || undefined,
                    fragment: result[iidxes.url.fragment] || undefined,
                    reason: "url",
                });
            }
            else if (result[iidxes.isFile]) {
                const filePath = string.substr(8);
                found.push({
                    start,
                    end,
                    string,
                    isFile: true,
                    protocol: result[iidxes.file.protocol],
                    filename: result[iidxes.file.fileName],
                    filePath,
                    fileDirectory: filePath.substr(0, filePath.length - result[iidxes.file.fileName].length),
                    reason: "file",
                });
            }
            else if (result[iidxes.isEmail]) {
                found.push({
                    start,
                    end,
                    string,
                    isEmail: true,
                    local: result[iidxes.email.local],
                    protocol: result[iidxes.email.protocol],
                    host: result[iidxes.email.host],
                    reason: "email",
                });
            }
            else {
                found.push({
                    start,
                    end,
                    string,
                    reason: "unknown",
                });
            }
        }
    } while (result);
    return found;
};
export default list;
//# sourceMappingURL=index.js.map